'use client';
import React from 'react';
import { useSession } from 'next-auth/react';
import { useRouter } from 'next/navigation';

type User = {
    name?: string | null;
    email?: string | null;
    role?: string;
    requiresActivation?: boolean;
};

export default function Page() {
    const { data: session, status, update } = useSession();
    const router = useRouter();
    const [hasRedirected, setHasRedirected] = React.useState(false);
    const [sessionRefreshed, setSessionRefreshed] = React.useState(false);

    React.useEffect(() => {
        if (status === 'loading') return;
        if (hasRedirected) return;

        const checkAndRedirect = async () => {
            // If we have a session, redirect based on role
            if (session?.user) {
                setHasRedirected(true);
                const user = session.user as User;
                if (user.requiresActivation) {
                    router.replace('/activate');
                    return;
                }
                if (user.role === 'employee') {
                    router.replace('/asset-accounts');
                    return;
                }
                if (user.role === 'compliance officer') {
                    router.replace('/employees');
                    return;
                }
                router.replace('/auth/signin');
                return;
            }

            // No session: try refresh once (e.g. after MFA when layout didn't re-run)
            if (!sessionRefreshed) {
                setSessionRefreshed(true);
                await update();
                return; // Re-run after update() propagates session
            }

            setHasRedirected(true);
            router.replace('/auth/signin');
        };

        checkAndRedirect();
    }, [session, status, hasRedirected, sessionRefreshed, update, router]);

    // Show loading indicator while checking session or redirecting
    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
            <p>Loading...</p>
        </div>
    );
}
